// @ts-nocheck
export const FETCH_CONTRACTOR_ASSIGNED_POSITIONS_REQUEST =
  "FETCH_CONTRACTOR_ASSIGNED_POSITIONS_REQUEST";
export const FETCH_CONTRACTOR_ASSIGNED_POSITIONS_SUCCESS =
  "FETCH_CONTRACTOR_ASSIGNED_POSITIONS_SUCCESS";
export const FETCH_CONTRACTOR_ASSIGNED_POSITIONS_FAILURE =
  "FETCH_CONTRACTOR_ASSIGNED_POSITIONS_FAILURE";

// clear schedule data
export const CLEAR_SCHEDULE_DATA = "CLEAR_SCHEDULE_DATA";

// update schedule data
export const UPDATE_SCHEDULE_DATA = "UPDATE_SCHEDULE_DATA";

// fetch only logs
export const FETCH_CONTRACTOR_LOGS_REQUEST = "FETCH_CONTRACTOR_LOGS_REQUEST";
export const FETCH_CONTRACTOR_LOGS_SUCCESS = "FETCH_CONTRACTOR_LOGS_SUCCESS";
export const FETCH_CONTRACTOR_LOGS_FAILURE = "FETCH_CONTRACTOR_LOGS_FAILURE";